export default __webpack_public_path__ + "static/media/770.d93d9f07.png";